module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門1_6.9cdf37b6.png";